import axios from '@/utils/axios'
import {getBackendByRole} from '@/utils/role'

/**
 * 刷新Token
 */
export const refreshToken = params => {
  return axios({
    url: `${getBackendByRole()}/user/refreshToken`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/common/login.js